import React from 'react';
import { Header, Icon, Popup, Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';
import { Fecha, LinkAlumno, LinkCurso, NombrePersonal } from 'src/componentes';

export type Props = Readonly<{
    registros: Readonly<Resultados<'recuperacionesAgendadasHoy'>>;
    alEliminar: (idRegistro: string) => void;
}>;

export const RegistrosDelDia = (props: Props) => {
    const { registros, alEliminar } = props;

    return (
        <div>
            <Header as='h2' content='Agendadas hoy' />

            <Table collapsing>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Alumno' />
                        <Table.HeaderCell content='Curso de origen' />
                        <Table.HeaderCell content='Curso de destino' />
                        <Table.HeaderCell content='Fecha de recuperación' />
                        <Table.HeaderCell content='Ingresado por' />
                        <Table.HeaderCell />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {registros.map(registro => (
                        <Table.Row key={registro.id}>
                            <LinkAlumno
                                numeroDeContrato={registro.alumno.numeroDeMatricula}
                                nombre={registro.alumno.nombre}
                                paraTabla
                            />
                            <Table.Cell
                                selectable={registro.cursoDeOrigen !== '<eliminado>'}
                                content={
                                    registro.cursoDeOrigen !== '<eliminado>' ? (
                                        <LinkCurso codigo={registro.cursoDeOrigen} />
                                    ) : (
                                        'eliminado'
                                    )
                                }
                            />
                            <Table.Cell
                                selectable={registro.cursoDeDestino !== '<eliminado>'}
                                content={
                                    registro.cursoDeDestino !== '<eliminado>' ? (
                                        <LinkCurso codigo={registro.cursoDeDestino} />
                                    ) : (
                                        'eliminado'
                                    )
                                }
                            />
                            <Table.Cell content={<Fecha fecha={registro.fecha} />} />
                            <Table.Cell>
                                <NombrePersonal
                                    nombre={registro.ingresadoPor.nombre}
                                    patron='%N %P'
                                />
                            </Table.Cell>

                            <Table.Cell>
                                <Popup
                                    trigger={
                                        <Icon
                                            circular
                                            link
                                            name='close'
                                            onClick={() => alEliminar(registro.id)}
                                        />
                                    }
                                    content='Eliminar'
                                    inverted
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Recuperaciones/RegistrosDelDia.tsx